import * as yup from 'yup'

import helpers from 'helpers'

const schemaFaq = yup.object().shape({
  faqsDocumentationsCategoryId: yup.string().required(),
  visualization: yup.string().required(),
  title: yup.string().required(),
  subtitle: yup.string().required(),
  description: yup
    .string()
    .required()
    .test(
      'hasContent',
      'Preencha esse campo',
      helpers.validates.jodit.hasContent,
    ),
})

export default schemaFaq
